import MappingOriginOption from "~/models/mapping/mappingOriginOption";
import Form from "../../../formability/form_builder/models/form";

export default class MappingOriginOptionForm extends MappingOriginOption<Form> {
  ORIGIN_TYPE: 'form' = 'form'
  type: 'single' = 'single'

  get title(): string {
    return this.origin.title
  }

  get id(): string {
    return this.origin.client_id
  }
}
